import React from 'react';

const FooterCopyright = () => {
  const year = new Date().getFullYear();
  return (
    <div className="bg-ink-900 text-ink-400 border-t border-white/5">
      <div className="container mx-auto px-4 lg:px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-sm">
        <p>&copy; {year} Fretz. Todos os direitos reservados.</p>
        <p className="text-ink-500">Feito em Goiânia, com café e propulsão.</p>
      </div>
    </div>
  );
};

export default FooterCopyright;
